module.exports = __webpack_public_path__ + "media/images/nav_icons/editor-0573c40e90e726c78f7623afbc804975.png";